import { j as t } from "../../../jsx-runtime-B6kdoens.js";
import { useState as E, useEffect as M } from "react";
import { useFloating as O, autoUpdate as R, hide as H, offset as T, useTransitionStatus as W, useTransitionStyles as z, useClick as U, useDismiss as q, useHover as G, safePolygon as J, useRole as K, useInteractions as L, useId as Q, FloatingPortal as V, FloatingFocusManager as X } from "@floating-ui/react";
import { c as d, a as f } from "../../../index-CROKJrb5.js";
import { c as Y, f as Z } from "../../../create-component-CBAeEoQ6.js";
import { NavigationItem as _ } from "../NavigationItem/index.js";
import { ChevronIcon as $ } from "../../Icon/icons/ChevronIcon/index.js";
import { w as ee } from "../../../atom-provider-B3P183Tj.js";
import { c as te, N as re, u as oe } from "../../../NavigationDropdownState-CxCC5dTJ.js";
import { b as se } from "../../../react-B_GApDuV.js";
const ae = d({
  base: "cur-flex cur-bg-surface-neutral focus-within:cur-outline-none cur-overflow-auto cur-max-h-[calc(100vh-4rem)] md:cur-max-h-[calc(100vh-5rem)]",
  variants: {
    mega: {
      true: "cur-flex-row",
      false: "cur-p-5"
    }
  }
}), ne = d({
  base: "cur-flex cur-flex-nowrap cur-items-center hover:cur-text-primary hover:cur-no-underline focus:cur-bg-surface-brand-light focus:cur-text-primary active:cur-bg-surface-brand-light hover:cur-bg-surface-highlight",
  variants: {
    open: {
      true: "cur-bg-surface-brand-light cur-text-primary hover:cur-bg-surface-brand-light"
    }
  }
}), ve = ee(
  Y(
    "NavigationDropdown",
    Z(
      ({
        children: p,
        className: g,
        closeRef: o,
        disabled: c,
        mega: s = !1,
        title: h,
        ...u
      }, v) => {
        const { openAtom: x } = oe(), [r, a] = se(x), [b, w] = E(!1), { x: l, y, refs: n, strategy: N, context: e } = O({
          open: r,
          onOpenChange: (m, i) => {
            m && w((i == null ? void 0 : i.type) === "click"), a(m);
          },
          placement: "bottom",
          whileElementsMounted: R,
          middleware: [H(), T(16)]
        }), { status: C, isMounted: D } = W(e), { styles: j } = z(e), F = U(e), I = q(e), k = G(e, {
          handleClose: J(),
          move: !1
        }), A = K(e), { getReferenceProps: P, getFloatingProps: S } = L([
          F,
          I,
          k,
          A
        ]), B = Q();
        return M(() => {
          o && (o.current = () => {
            a(!1);
          });
        }, [o, a]), /* @__PURE__ */ t.jsxs(
          "div",
          {
            className: f(
              "cur-text-line-height-h2 cur-z-20 cur-flex cur-list-none cur-text-body cur-font-bold",
              g
            ),
            ref: v,
            ...u,
            children: [
              /* @__PURE__ */ t.jsxs(
                _,
                {
                  ref: n.setReference,
                  ...c ? {} : P(),
                  className: ne({
                    open: r
                  }),
                  children: [
                    h,
                    /* @__PURE__ */ t.jsx(
                      $,
                      {
                        className: f("cur-transition-transform", {
                          "cur-rotate-90": !r,
                          "-cur-rotate-90": r
                        })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ t.jsx(V, { children: D && !c ? /* @__PURE__ */ t.jsx(
                X,
                {
                  context: e,
                  initialFocus: n.floating,
                  visuallyHiddenDismiss: !0,
                  returnFocus: b,
                  children: /* @__PURE__ */ t.jsx(
                    "div",
                    {
                      className: ae({ mega: s }),
                      ref: n.setFloating,
                      style: {
                        position: N,
                        top: y,
                        left: l && !s ? l : 0,
                        width: s ? "100%" : "auto",
                        height: "auto",
                        visibility: C !== "unmounted" ? "visible" : "hidden",
                        ...u.style,
                        ...j
                      },
                      "aria-labelledby": B,
                      ...S(),
                      children: p
                    }
                  )
                }
              ) : null })
            ]
          }
        );
      }
    )
  ),
  re,
  te
);
export {
  ve as NavigationDropdown
};
//# sourceMappingURL=index.js.map
